import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { router } from './router/index.js';
import './assets/index.css';

const app = createApp(App);

app.use(createPinia());
app.use(router);

app.config.errorHandler = (err, _instance, info) => {
  console.error('[vue] Unhandled error:', err);
  console.error('[vue] Info:', info);
};

app.mount('#app');
